import * as s from "react";
import a from "../lib/IconBase.es.js";
import r from "../defs/ListDashes.es.js";
const e = s.forwardRef((o, t) => /* @__PURE__ */ s.createElement(a, { ref: t, ...o, weights: r }));
e.displayName = "ListDashesIcon";
const c = e;
export {
  c as ListDashes,
  e as ListDashesIcon
};
